import React, { useState, useEffect } from "react";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { COUNTRY, CIRCLES_PAYMENT_PLUGIN_ORIGIN_KEY } from "utils/constants";
import { Flex } from "ui-components";
import Spinner, { styles } from "components/Spinner";
import "./styles.css";
import { getLocaleOrDefault } from "utils/localStorage";
// https://docs.adyen.com/checkout/web-sdk/

export const loadDropin = props => {
  const { paymentRequestData = {}, onSubmit = () => {} } = props;
  const defaultLocale = `${getLocaleOrDefault()}-${COUNTRY.toUpperCase()}`;
  const action_object = paymentRequestData.action_object;
  const configuration = {
    paymentMethodsResponse: {
      paymentMethods: get(action_object, "payment_methods")
    },
    originKey: paymentRequestData.origin || CIRCLES_PAYMENT_PLUGIN_ORIGIN_KEY,
    locale: paymentRequestData.locale || defaultLocale,
    environment: paymentRequestData.environment,
    paymentMethodsConfiguration: {
      card: {
        // Example optional configuration for Cards
        hasHolderName: false,
        holderNameRequired: false,
        enableStoreDetails: false,
        hideCVC: false, // Change this to true to hide the CVC field for stored cards
        name: "Credit/Debit card"
      }
    }
  };

  try {
    const checkout = new window.AdyenCheckout(configuration);

    checkout
      .create("dropin", {
        amount: {
          value: action_object.amount || 0,
          currency: action_object.currency
        },
        onSubmit,
        onAdditionalDetails: (state, dropin) => {
          console.log(
            "Future use case => handle the onAdditionalDetails process request"
          );
        }
      })
      .mount("#payment");
    return checkout;
  } catch (error) {
    console.log("Error while loadDropin ", error);
  }
};

const PaymentAdyenDropin = props => {
  const [dropinLoaded, setDropinLoaded] = useState(false);

  useEffect(() => {
    const { paymentRequestData = {}, loading } = props;

    if (!loading && !isEmpty(paymentRequestData) && !dropinLoaded) {
      const init = setInterval(() => {
        if (isFunction(window.AdyenCheckout)) {
          clearInterval(init);
          const dropin = loadDropin(props);
          if (!isEmpty(dropin)) {
            setDropinLoaded(true);
          }
        }
      }, 1000);
    }
  }, [props, dropinLoaded]);

  return (
    <Flex
      className={!dropinLoaded ? "loading" : ""}
      id="payment"
      alignItems={"center"}
      justifyContent={"center"}
    >
      {!dropinLoaded && <Spinner sx={styles.modalContainer} />}
    </Flex>
  );
};

export default PaymentAdyenDropin;
